 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		6: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		6: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"e792c19e8bb39070e1e019cd2581b40b64003729","1":"styles","2":"e7e6746ed7073f349cd7e3abdefe95ab3c6a7b30","3":"925d4bd7dc12468141a4b5a3fae92b5f90e7e3d5","4":"485190ac84296fe3224315986113f44a4b7e82bb","5":"8c4ddb761b8de10f9df088fe974d582bc6445f96","8":"component---cache-caches-gatsby-plugin-offline-app-shell-js","9":"component---src-pages-404-js","10":"component---src-pages-about-us-js","11":"component---src-pages-app-js","12":"component---src-pages-bigdiscountdays-tnc-index-js","13":"component---src-pages-blog-js","14":"component---src-pages-careers-js","15":"component---src-pages-cashback-terms-conditions-js","16":"component---src-pages-communications-js","17":"component---src-pages-contact-js","18":"component---src-pages-ecommerce-js","19":"component---src-pages-faq-solv-score-js","20":"component---src-pages-index-js","21":"component---src-pages-information-security-policy-js","22":"component---src-pages-media-index-js","23":"component---src-pages-media-press-js","24":"component---src-pages-partners-shopmatic-index-js","25":"component---src-pages-posh-policy-js","26":"component---src-pages-privacy-policy-js","27":"component---src-pages-promos-april-offer-2024-tnc-index-js","28":"component---src-pages-promos-apriloffers-tnc-index-js","29":"component---src-pages-promos-august-offer-2024-tnc-index-jsx","30":"component---src-pages-promos-august-offers-tnc-index-js","31":"component---src-pages-promos-bigdiscountdays-tnc-offer-2-index-js","32":"component---src-pages-promos-bigdiscountdays-tnc-offer-3-index-js","33":"component---src-pages-promos-decemberoffers-tnc-index-js","34":"component---src-pages-promos-delhi-ncr-offer-tnc-index-js","35":"component---src-pages-promos-februaryoffers-tnc-index-js","36":"component---src-pages-promos-festiveoffer-tnc-index-js","37":"component---src-pages-promos-fmcg-horeca-offer-tnc-index-js","38":"component---src-pages-promos-januaryoffers-tnc-index-js","39":"component---src-pages-promos-july-offer-2024-tnc-index-js","40":"component---src-pages-promos-july-offer-3-tnc-index-js","41":"component---src-pages-promos-julyoffer-tnc-index-js","42":"component---src-pages-promos-julyoffers-tnc-index-js","43":"component---src-pages-promos-june-offer-2023-tnc-index-js","44":"component---src-pages-promos-june-offer-2024-tnc-index-js","45":"component---src-pages-promos-juneoffers-tnc-index-js","46":"component---src-pages-promos-marchoffers-tnc-index-js","47":"component---src-pages-promos-may-offer-2024-tnc-index-js","48":"component---src-pages-promos-mayoffers-tnc-index-js","49":"component---src-pages-promos-november-offer-2023-tnc-index-js","50":"component---src-pages-promos-novemberoffers-tnc-index-js","51":"component---src-pages-promos-octoberoffers-tnc-index-js","52":"component---src-pages-promos-ramadanfestiveoffer-tnc-index-js","53":"component---src-pages-promos-september-offer-2024-tnc-index-js","54":"component---src-pages-promos-septemberoffers-tnc-index-js","55":"component---src-pages-promos-smedy-offer-tnc-index-js","56":"component---src-pages-promos-solv-dhamaka-tnc-index-js","57":"component---src-pages-promos-solv-offer-tnc-index-js","58":"component---src-pages-promos-solvsureactiveoffer-tnc-index-js","59":"component---src-pages-promos-supersaver-tnc-index-js","60":"component---src-pages-referral-tnc-js","61":"component---src-pages-return-shipment-policy-js","62":"component---src-pages-services-business-services-js","63":"component---src-pages-services-financial-services-js","64":"component---src-pages-smedy-offer-tnc-index-js","65":"component---src-pages-sms-read-terms-and-condition-js","66":"component---src-pages-solv-sure-active-js","67":"component---src-pages-terms-of-services-js","68":"component---src-templates-press-article-js"}[chunkId]||chunkId) + "-" + {"0":"686548ea470c09ca9c5b","1":"e9d24b1846c7d6eb9685","2":"325436e3ee73d965107b","3":"3049c2d319875b7c114d","4":"7abc8ccdd1825185b775","5":"c49452f567cc49dff230","8":"a95b272f8c25b9a8a758","9":"088231f6a24f3455516f","10":"fd2854dae97fb45541b8","11":"6d5b626b143093176422","12":"75b60fc4eb7f22be2f9b","13":"16a608c53c44197ce72a","14":"8946f164ce605f8ca918","15":"0520b6f87bdbfb5d486d","16":"07ca140c4745f4a14017","17":"288c1c97289988ed657f","18":"dd1f4a05cfc9d61cc214","19":"429ac4f692484eead516","20":"1558155ae22bf0bc2eaf","21":"b530fcfdb1af264415fd","22":"192e1d871acf9178a6cd","23":"15dcbe9424b2849994fc","24":"8a934f92b9250724db79","25":"36aef08f339bc81a079e","26":"df36cd5809e2556d778c","27":"f60c5d5c0176ef6303fd","28":"5561ec0dfddb0cdc8b64","29":"0b8bf2db38330e44a7f2","30":"5c46dedb81ba15325558","31":"6c6f5a45abd57b1f393e","32":"c3075128d6d1e390a4f3","33":"3fbea82c7a8f68f5d2ab","34":"75725955fc27f534db99","35":"44c0eb366d4c3e4f9a05","36":"784a5963be9e1404c671","37":"c0f4cad45ca9071b3790","38":"9214b6863be72116aa94","39":"4c969d0cb123e0cae0c8","40":"cb41fc6a1d32a1ada405","41":"c3abd84159dc95d9b8f0","42":"ebb6c186178834c0acdb","43":"883ba1ffd3462bdf06bf","44":"805274813118bbd0ded8","45":"0bc86aae3eca19a9d8e1","46":"27eee1c0248b121c5d27","47":"74351b96b0c342c9ae65","48":"a1aeb209a4cd4b8ecd2b","49":"9ea64989ac41b0d60034","50":"3030749acbee72cc81f7","51":"bbc599abff00652ce2ce","52":"b29d1dc740a48df24e7f","53":"70cc5cdfd5139a7e2daf","54":"9a2b4ea243f6df8ed8ed","55":"b51e333a927c8ebbd1bf","56":"c0432da3f3bd960e2c6a","57":"9ab26f9656f1805a7994","58":"129d9d800978c1ccc089","59":"b5ea27a97574f92a1c6c","60":"a65d9e585f507d64e901","61":"83f06931dbe64e01c332","62":"a97ae800c8978c55d6a5","63":"a736c5d8b252dd283815","64":"11661a8cd2501e1c09f2","65":"6d9d99db0f2aba0cb069","66":"734cbe121eac7302dfc1","67":"248eb01326549c5af268","68":"0ef25f2fefc61e114344"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"e792c19e8bb39070e1e019cd2581b40b64003729","1":"styles","2":"e7e6746ed7073f349cd7e3abdefe95ab3c6a7b30","3":"925d4bd7dc12468141a4b5a3fae92b5f90e7e3d5","4":"485190ac84296fe3224315986113f44a4b7e82bb","5":"8c4ddb761b8de10f9df088fe974d582bc6445f96","8":"component---cache-caches-gatsby-plugin-offline-app-shell-js","9":"component---src-pages-404-js","10":"component---src-pages-about-us-js","11":"component---src-pages-app-js","12":"component---src-pages-bigdiscountdays-tnc-index-js","13":"component---src-pages-blog-js","14":"component---src-pages-careers-js","15":"component---src-pages-cashback-terms-conditions-js","16":"component---src-pages-communications-js","17":"component---src-pages-contact-js","18":"component---src-pages-ecommerce-js","19":"component---src-pages-faq-solv-score-js","20":"component---src-pages-index-js","21":"component---src-pages-information-security-policy-js","22":"component---src-pages-media-index-js","23":"component---src-pages-media-press-js","24":"component---src-pages-partners-shopmatic-index-js","25":"component---src-pages-posh-policy-js","26":"component---src-pages-privacy-policy-js","27":"component---src-pages-promos-april-offer-2024-tnc-index-js","28":"component---src-pages-promos-apriloffers-tnc-index-js","29":"component---src-pages-promos-august-offer-2024-tnc-index-jsx","30":"component---src-pages-promos-august-offers-tnc-index-js","31":"component---src-pages-promos-bigdiscountdays-tnc-offer-2-index-js","32":"component---src-pages-promos-bigdiscountdays-tnc-offer-3-index-js","33":"component---src-pages-promos-decemberoffers-tnc-index-js","34":"component---src-pages-promos-delhi-ncr-offer-tnc-index-js","35":"component---src-pages-promos-februaryoffers-tnc-index-js","36":"component---src-pages-promos-festiveoffer-tnc-index-js","37":"component---src-pages-promos-fmcg-horeca-offer-tnc-index-js","38":"component---src-pages-promos-januaryoffers-tnc-index-js","39":"component---src-pages-promos-july-offer-2024-tnc-index-js","40":"component---src-pages-promos-july-offer-3-tnc-index-js","41":"component---src-pages-promos-julyoffer-tnc-index-js","42":"component---src-pages-promos-julyoffers-tnc-index-js","43":"component---src-pages-promos-june-offer-2023-tnc-index-js","44":"component---src-pages-promos-june-offer-2024-tnc-index-js","45":"component---src-pages-promos-juneoffers-tnc-index-js","46":"component---src-pages-promos-marchoffers-tnc-index-js","47":"component---src-pages-promos-may-offer-2024-tnc-index-js","48":"component---src-pages-promos-mayoffers-tnc-index-js","49":"component---src-pages-promos-november-offer-2023-tnc-index-js","50":"component---src-pages-promos-novemberoffers-tnc-index-js","51":"component---src-pages-promos-octoberoffers-tnc-index-js","52":"component---src-pages-promos-ramadanfestiveoffer-tnc-index-js","53":"component---src-pages-promos-september-offer-2024-tnc-index-js","54":"component---src-pages-promos-septemberoffers-tnc-index-js","55":"component---src-pages-promos-smedy-offer-tnc-index-js","56":"component---src-pages-promos-solv-dhamaka-tnc-index-js","57":"component---src-pages-promos-solv-offer-tnc-index-js","58":"component---src-pages-promos-solvsureactiveoffer-tnc-index-js","59":"component---src-pages-promos-supersaver-tnc-index-js","60":"component---src-pages-referral-tnc-js","61":"component---src-pages-return-shipment-policy-js","62":"component---src-pages-services-business-services-js","63":"component---src-pages-services-financial-services-js","64":"component---src-pages-smedy-offer-tnc-index-js","65":"component---src-pages-sms-read-terms-and-condition-js","66":"component---src-pages-solv-sure-active-js","67":"component---src-pages-terms-of-services-js","68":"component---src-templates-press-article-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"8e97e6ba42f2db11bafe","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
